import React from 'react';

type SplitTextProps = {
  text: string;
  className?: string;
  /** Index de départ pour le décalage d'animation (--i) quand plusieurs lignes s'enchaînent */
  startIndex?: number;
};

/**
 * Découpe un texte en mots puis en caractères (spans) pour animer lettre par lettre.
 * Chaque caractère expose la variable CSS --i (index global) pour un stagger en CSS/GSAP.
 */
const SplitText: React.FC<SplitTextProps> = ({ text, className, startIndex = 0 }) => {
  const words = text.split(' ');
  let index = startIndex;

  return (
    <span className={`ts-split ${className || ''}`} aria-label={text}>
      {words.map((word, wi) => {
        const chars = Array.from(word);
        return (
          <React.Fragment key={`${word}-${wi}`}>
            <span className="ts-word" aria-hidden="true">
              {chars.map((ch, ci) => {
                const i = index++;
                return (
                  <span
                    key={`${ch}-${ci}`}
                    className="ts-char"
                    style={{ ['--i' as any]: i }}
                  >
                    {ch}
                  </span>
                );
              })}
            </span>
            {wi < words.length - 1 && <span className="ts-space" aria-hidden="true"> </span>}
          </React.Fragment>
        );
      })}
    </span>
  );
};

export const countChars = (text: string) => text.replace(/ /g, '').length;

export default SplitText;
